import { render, staticRenderFns } from "./randot_vertical.config.vue?vue&type=template&id=53d2a1ef"
import script from "./randot_vertical.config.vue?vue&type=script&lang=js"
export * from "./randot_vertical.config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports